import { Route, Routes } from "react-router-dom";
import { TopicList } from "./TopicList";
import { TopicView } from "./TopicView";
import { StoryView } from "./story/StoryView";

export const DonghwaPage = () => {

  return (
    <div className="donghwaPage">
      <Routes>
        <Route path="/" element={<TopicList />} />
        <Route path="/:topicId/*" element={<TopicView />} />
        <Route path="/story/:storyId" element={<StoryView />} />
      </Routes>
    </div>
  );
};